module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "订单详情"
    }
  }), _vm._v(" "), (_vm.data) ? _c('header', [(_vm.data.grouplog_info) ? _c('div', [(_vm.data.grouplog_info.groupbuyEx == 0 && _vm.data.grouplog_info.isFullGroup == 1) ? _c('span', [_vm._v("拼团成功等待卖家发货")]) : _vm._e(), _vm._v(" "), (_vm.data.grouplog_info.groupbuyEx == 0 && _vm.data.grouplog_info.isFullGroup == 0) ? _c('div', [_c('span', [_vm._v("还差" + _vm._s(_vm.data.grouplog_info.groupCount) + "人就可以满团了")]), _vm._v(" "), _c('p', [_vm._v("点击右上角 选择分享按钮 邀请你的好友一起来参团吧")])]) : _vm._e(), _vm._v(" "), (_vm.data.grouplog_info.groupbuyEx == 1) ? _c('div', [_c('span', [_vm._v("拼团失败 已超时")]), _vm._v(" "), _c('p', [_vm._v("支付款将退回到支付账号请注意查收")])]) : _vm._e()]) : _c('div', [_vm._m(0)])]) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('div', [_c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icon-weizhi"
  }), _vm._v("收件人:" + _vm._s(_vm.data.receiver_name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.receiver_mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "address-info text-l"
  }, [_vm._v("收货地址:" + _vm._s(_vm.data.receiver_state + _vm.data.receiver_city + _vm.data.receiver_address))])]), _vm._v(" "), _vm._l((_vm.data.orders), function(item) {
    return _c('router-link', {
      key: item.item_id,
      staticClass: "order-info flex text-l",
      attrs: {
        "tag": "div",
        "to": {
          name: 'detail',
          params: {
            id: item.item_id
          }
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticClass: "img-block",
      attrs: {
        "src": item.pic_path,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "l flex flex-1"
    }, [_c('div', {
      staticClass: "text"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.spec_nature_info))])]), _vm._v(" "), _c('div', {
      staticClass: "num flex"
    }, [_c('p', [_vm._v("X" + _vm._s(item.num))]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(item.price))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "pay-info text-l "
  }, [_c('div', [_c('span', [_vm._v("订单编号")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.tid))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("支付方式")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.payType))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("下单时间")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("timerForm")(_vm.data.created_time)))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("配送方式")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.post_template_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "pay-info text-l "
  }, [_c('div', [_c('span', [_vm._v("优惠")]), _vm._v(" "), _c('p', [_vm._v("￥" + _vm._s(_vm._f("priceFilter")(_vm.data.discount_fee)))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("应付金额")]), _vm._v(" "), _c('p', {
    staticClass: "red"
  }, [_vm._v("￥" + _vm._s(_vm.data.payment))])])])], 2) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("交易关闭")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31f8360e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/spellGroup/OrderDetail/OrderDetail.vue
// module id = 542
// module chunks = 0